module.exports = __webpack_public_path__ + "media/images/previous_page_icon-610f18b6d635d3df9bd7d2ab369fe7a6.svg";